import React, { useCallback, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import filterTypes from "data/filter-types";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { search, finishRent } from "actions/chargers/activeRent/actions";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import Spinner from "views/lib/components/Spinner";

const PowerBankRentActive = ({
                               userId,
                               list,
                               search,
                               finishRent,
                             }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    search(0, 1000, "start,DESC", [{
      fieldName: "user",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [search, userId]);

  const handleFinish = useCallback((qr, id) => {
    setLoading(true);
    finishRent(qr, id, () => setLoading(false));
  }, [finishRent]);

  return (
    <div className="position-relative">
      {!loading || <Spinner/>}
      <div style={{ overflowX: "auto" }}>
        <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
          <thead>
          <tr>
            <th>ID</th>
            <th>Power Bank</th>
            <th>Scan</th>
            <th>Start</th>
            <th>End</th>
            <th>Start Station</th>
            <th>End Station</th>
            <th>Amount</th>
            <th>Billing Amount</th>
            <th>State</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          {((list && list.content) || []).map(item => (
            <tr key={item.id}>
              <td>
                {item.id}
              </td>
              <td>
                {item.powerBank}
              </td>
              <td>
                {item.scan ? moment(item.scan)
                  .format("HH:mm YYYY-MM-DD") : "N/A"}
              </td>
              <td>
                {item.start ? moment(item.start)
                  .format("HH:mm YYYY-MM-DD") : "N/A"}
              </td>
              <td>
                {item.end ? moment(item.end)
                  .format("HH:mm YYYY-MM-DD") : "N/A"}
              </td>
              <td>
                {item.startStationQR ? <Link to={`/chargers/stations/list/${item.startStationQR}`}>
                  {item.startStationQR}
                </Link> : "N/A"}
              </td>
              <td>
                {item.endStationQR ? <Link to={`/chargers/stations/list/${item.endStationQR}`}>
                  {item.endStationQR}
                </Link> : "N/A"}
              </td>
              <td>{item.billingDetails && item.billingDetails.amount ? item.billingDetails.amount : "N/A"}</td>
              <td>{item.billingDetails && item.billingDetails.billingAmount ? item.billingDetails.billingAmount : "N/A"}</td>
              <td>{item.state}</td>
              <td>
                <Popconfirm
                  title="Are you sure you want to finish this trip?"
                  onConfirm={() => handleFinish(item.startStationQR, item.id)}
                  placement="top"
                  okText="Yes"
                  cancelText="Cancel"
                >
                  <button
                    className="btn btn-sm btn-warning"
                    title="Finish rent"
                  >
                    Finish
                  </button>
                </Popconfirm>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.powerBankActiveRent.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finishRent: bindActionCreators(finishRent, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PowerBankRentActive);



// WEBPACK FOOTER //
// ./src/views/pages/users/power-bank-rent-active.js